module.exports = __webpack_public_path__ + "img/download.c9369923.svg";